import { ClinicConfig, Appointment, DaySlot } from '../types';
import { getAvailableAttendance, validateSlot, todaySP } from './schedulingRules';

export const formatDateBr = (dateString: string): string => {
  if (!dateString) return '';
  const [year, month, day] = dateString.split('-');
  return `${day}/${month}/${year}`;
};

export const getDayOfWeek = (dateString: string): number => {
  // Create date object. Note: input is YYYY-MM-DD
  // We append T12:00:00 to avoid timezone rolling back the day
  const date = new Date(`${dateString}T12:00:00`);
  return date.getDay();
};

export const generateTimeSlots = (
  date: string,
  config: ClinicConfig,
  appointments: Appointment[]
): DaySlot[] => {
  const slots: DaySlot[] = [];
  const { startHour, endHour, intervalMinutes } = config;
  if (intervalMinutes <= 0 || config.slotDurationMinutes <= 0) return [];

  // 1. Check if date is blocked manually
  if (getAvailableAttendance(date, config).length === 0) {
    return [];
  }

  // 2. Check if day of week is working day
  // 3. Generate slots
  let current = convertTimeToMinutes(startHour);
  const end = convertTimeToMinutes(endHour);

  while (current + config.slotDurationMinutes <= end) {
    const timeString = convertMinutesToTime(current);

    // Check if booked
    const isBooked = appointments.some(
      (appt) => appt.time === timeString && appt.date === date && appt.status !== 'cancelled'
    );

    // Check if in the past (if today)
    const isPast = validateSlot(date, timeString, getAvailableAttendance(date, config)[0], config) !== null;

    const isBlocked = config.blockedSlots?.some(slot => slot.date === date && slot.time === timeString);
    if (!isBooked && !isPast && !isBlocked) {
      slots.push({
        time: timeString,
        available: true,
      });
    }

    current += intervalMinutes;
  }

  return slots;
};

// Helpers
function convertTimeToMinutes(time: string): number {
  const [hours, minutes] = time.split(':').map(Number);
  return hours * 60 + minutes;
}

function convertMinutesToTime(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
}

export const getNextDays = (startDate: Date, days: number): string[] => {
  const dates = [];
  for (let i = 0; i < days; i++) {
    const d = new Date(`${todaySP(startDate)}T12:00:00-03:00`);
    d.setUTCDate(d.getUTCDate() + i);
    dates.push(d.toISOString().split('T')[0]);
  }
  return dates;
};
